import {EntityModel} from "@fedeltapointofsale/data-client";
import {TableDefinitionData} from "./table-definition.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TableDefinitionEntityModel extends EntityModel<TableDefinitionData> {
    constructor(injector: Injector) {
        super(injector, TableDefinitionData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
